import { Controller } from "@hotwired/stimulus"

// Controller for handling dropdown menus in admin sidebars
export default class extends Controller {
  static targets = ["menu", "toggle", "icon"]

  // Store state
  static values = {
    expanded: Boolean
  }

  connect() {
    // Initialize all menus to be hidden by default
    if (this.hasMenuTarget) {
      // Force the menu to be hidden on initial load
      this.hide()
    }

    // Initialize expanded value
    this.expandedValue = false
  }

  toggle(event) {
    if (event) event.preventDefault()

    // Toggle menu visibility
    if (this.hasMenuTarget) {
      // Check current state
      const isHidden = this.menuTarget.classList.contains("tw-hidden");

      if (isHidden) {
        // First, close any other open menus
        this.closeOtherMenus()

        // Then show this menu
        this.show()
      } else {
        // Hide the menu
        this.hide()
      }
    }
  }

  // Close other open menus before opening this one
  closeOtherMenus() {
    // Find all other dropdown controllers
    const allDropdownControllers = this.application.controllers.filter(
      controller => controller.context.identifier === 'sidebar-dropdown' && controller !== this
    )

    // Close other open menus
    allDropdownControllers.forEach(controller => {
      if (typeof controller.hide === 'function') {
        controller.hide()
      }
    })
  }

  // Explicit show/hide methods for programmatic control
  show() {
    if (this.hasMenuTarget) {
      // Remove classes that hide the menu
      this.menuTarget.classList.remove("tw-hidden")

      this.expandedValue = true

      // Update icon if available
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("fa-chevron-down")
        this.iconTarget.classList.add("fa-chevron-up")
      }
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      // Add classes that hide the menu
      this.menuTarget.classList.add("tw-hidden")

      this.expandedValue = false

      // Update icon if available
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("fa-chevron-down")
        this.iconTarget.classList.remove("fa-chevron-up")
      }
    }
  }
}